import { createFileRoute } from '@tanstack/react-router'
import { SuspectScorePage } from 'features/suspectScore'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/suspect-score/')({
  component: SuspectScorePage,
})
